module.exports = __webpack_public_path__ + "static/media/LSM-logo.0b2ed220.png";